<template>
  <div class="text-center">
    <v-dialog v-model="isOpenDialog" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="900" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          Nhập EXCEL <v-spacer />
          <v-icon dark @click="cancel">close</v-icon>
        </v-card-title>
        <v-card-text class="pt-5">
          <!-- Bước chọn file -->
          <div
            v-if="step === 'import'"
            class="d-flex flex-column justify-center align-center mx-auto wrap"
            style="min-height: 280px"
          >
            <v-icon size="64" color="primary">mdi-file-excel</v-icon>
            <div class="mt-4">Tải tệp Excel (.xlsx) chứa danh sách học sinh (cột "Mã số")</div>
            <div class="mt-5">
              <v-btn color="primary" class="mr-4" outlined @click="downloadTemplate">Tải mẫu nhập</v-btn>
              <v-btn color="primary" depressed :loading="isSelecting" @click="onExcelUpload">
                Chọn tệp
                <input
                  ref="uploader"
                  type="file"
                  class="d-none"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="onFileChanged"
                />
              </v-btn>
            </div>
          </div>

          <!-- Bước preview -->
          <div v-else class="wrap pa-3">
            <div class="mb-2 font-weight-medium">Tệp: {{ fileName }} — {{ rows.length }} dòng</div>
            <v-data-table :headers="previewHeaders" :items="rows" :items-per-page="10" dense>
              <template v-slot:[`item.stt`]="{ index }">{{ index + 1 }}</template>
            </v-data-table>
          </div>
        </v-card-text>
        <hr color="#E0E0E0" />
        <v-card-actions>
          <v-btn class="ma-2" width="100px" outlined @click="cancel">Hủy</v-btn>
          <v-spacer />
          <v-btn class="ma-2" width="100px" dark depressed color="#0D47A1" :disabled="!rows.length" :loading="saving" @click="save">
            Lưu
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import readXlsxFile from 'read-excel-file'
import { get } from 'lodash'
import { MealGroupStudent } from '@/plugins/api'

const schema = {
  'Mã số': { prop: 'code', type: String },
  'Tên học sinh': { prop: 'name', type: String },
  'Ngày sinh': { prop: 'dob', type: String },
  'Giới tính': { prop: 'gender', type: String },
  Lớp: { prop: 'class', type: String },
  'Trạng thái': { prop: 'status', type: String }
}

export default {
  props: {
    groupId: { type: [String, Number], default: null }
  },
  data() {
    return {
      isOpenDialog: false,
      isSelecting: false,
      saving: false,
      step: 'import',
      fileName: '',
      rows: [],
      previewHeaders: [
        { text: 'STT', value: 'stt', sortable: false },
        { text: 'Mã số', value: 'code', sortable: false },
        { text: 'Tên học sinh', value: 'name', sortable: false },
        { text: 'Lớp', value: 'class', sortable: false }
      ]
    }
  },
  methods: {
    openDialog() {
      this.resetInput()
      this.isOpenDialog = true
    },
    cancel() {
      this.isOpenDialog = false
      this.resetInput()
    },
    resetInput() {
      this.step = 'import'
      this.fileName = ''
      this.rows = []
    },
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener('focus', () => { this.isSelecting = false }, { once: true })
      this.$refs.uploader.click()
    },
    downloadTemplate() {
      window.location.href = `${window.location.origin}/Danh sách HS vào nhóm đối tượng.xlsx`
    },
    async onFileChanged(e) {
      const file = e.target.files[0]
      if (!file) return
      this.$loading.active = true
      try {
        const result = await readXlsxFile(file, { schema })
        if (result.errors && result.errors.length) {
          const err = result.errors[0]
          this.$alert.error(`Lỗi Dòng ${err.row} - Cột ${err.column}: ${err.error}`)
          return
        }
        this.rows = (result.rows || []).filter(r => r.code)
        this.fileName = file.name
        this.step = 'send'
      } catch (err) {
        this.$alert.error({ title: 'File không đúng định dạng', description: 'Cần .xlsx theo mẫu' })
      } finally {
        this.$loading.active = false
        this.$refs.uploader.value = ''
      }
    },
    async save() {
      const codes = this.rows.map(r => String(r.code).trim()).filter(Boolean)
      if (!codes.length) return
      this.saving = true
      this.$loading.active = true
      try {
        // Gửi TẤT CẢ mã trong 1 request -> BE xử lý atomic (transaction): có mã sai thì không thêm gì.
        await MealGroupStudent.addStudentPack({ studentCodes: codes, groupId: this.groupId })
        this.$alert.success('Nhập Excel thành công!')
        this.isOpenDialog = false
        this.resetInput()
        this.$emit('added')
      } catch (e) {
        const msg = get(e, 'response.data.message') || e.message || e
        this.$alert.error('Nhập Excel thất bại: ' + msg)
      } finally {
        this.saving = false
        this.$loading.active = false
      }
    }
  }
}
</script>

<style scoped>
.wrap {
  border: 1px solid rgb(222, 222, 222);
  border-radius: 4px;
}
</style>
